/* ============================================================
   AYAME LUXURY — Custom Brand JavaScript
   Where power blooms.
   Drop this entire file into Shopify Edit Code:
   Atelier > assets > New asset > "ayame-custom.js"
   Then add this to theme.liquid before </body>:
   <script src="{{ 'ayame-custom.js' | asset_url }}" defer></script>
   ============================================================ */

(function(){
  'use strict';

  /* Respect reduced motion */
  const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- 1. Sticky nav: add scrolled class on scroll ---- */
  function initStickyNav(){
    const update = () => {
      if (window.scrollY > 60) {
        document.body.classList.add('ayame-scrolled');
      } else {
        document.body.classList.remove('ayame-scrolled');
      }
    };
    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  /* ---- 2. Letter-by-letter hero text ---- */
  function initHeroLetters(){
    document.querySelectorAll('.ayame-hero__title:not([data-split])').forEach(el => {
      const text = el.textContent.trim();
      el.setAttribute('data-split','true');
      el.innerHTML = text.split('').map(c => {
        if (c === ' ') return '<span class="letter">&nbsp;</span>';
        return `<span class="letter">${c}</span>`;
      }).join('');
    });
  }

  /* ---- 3. Falling crystals/diamonds in hero ---- */
  function initCrystals(){
    if (REDUCED) return;
    document.querySelectorAll('.ayame-hero').forEach(hero => {
      if (hero.querySelector('.ayame-crystals')) return;
      const canvas = document.createElement('canvas');
      canvas.className = 'ayame-crystals';
      hero.appendChild(canvas);
      const ctx = canvas.getContext('2d');
      let w, h, crystals = [];

      function resize(){
        w = canvas.width  = hero.offsetWidth;
        h = canvas.height = hero.offsetHeight;
      }
      resize();
      window.addEventListener('resize', resize);

      const COLORS = ['#c9a96e', '#e9e2da'];
      const COUNT = Math.max(28, Math.floor(w / 50));

      for (let i = 0; i < COUNT; i++){
        crystals.push({
          x: Math.random() * w,
          y: Math.random() * h,
          size: 2 + Math.random() * 4,
          speed: 0.2 + Math.random() * 0.6,
          drift: -0.3 + Math.random() * 0.6,
          rot: Math.random() * Math.PI * 2,
          rotSpeed: -0.01 + Math.random() * 0.02,
          color: COLORS[Math.floor(Math.random() * COLORS.length)],
          alpha: 0.35 + Math.random() * 0.55
        });
      }

      function drawDiamond(x, y, size, rot, color, alpha){
        ctx.save();
        ctx.translate(x, y);
        ctx.rotate(rot);
        ctx.globalAlpha = alpha;
        ctx.beginPath();
        ctx.moveTo(0, -size);
        ctx.lineTo(size * 0.7, 0);
        ctx.lineTo(0, size);
        ctx.lineTo(-size * 0.7, 0);
        ctx.closePath();
        ctx.fillStyle = color;
        ctx.fill();
        ctx.restore();
      }

      function tick(){
        ctx.clearRect(0, 0, w, h);
        crystals.forEach(c => {
          c.y += c.speed;
          c.x += c.drift;
          c.rot += c.rotSpeed;
          if (c.y > h + 10){ c.y = -10; c.x = Math.random() * w; }
          if (c.x > w + 10) c.x = -10;
          if (c.x < -10) c.x = w + 10;
          drawDiamond(c.x, c.y, c.size, c.rot, c.color, c.alpha);
        });
        requestAnimationFrame(tick);
      }
      tick();
    });
  }

  /* ---- 4. Click ripple (diamond) ---- */
  function initClickRipple(){
    if (REDUCED) return;
    document.addEventListener('click', e => {
      const el = document.createElement('div');
      el.className = 'ayame-ripple';
      el.style.left = e.clientX + 'px';
      el.style.top  = e.clientY + 'px';
      document.body.appendChild(el);
      setTimeout(() => el.remove(), 950);
    }, { passive: true });
  }

  /* ---- 5. Scroll-triggered fade-up sections ---- */
  function initScrollFade(){
    if (REDUCED){
      document.querySelectorAll('.ayame-fade-up').forEach(el => el.classList.add('is-visible'));
      return;
    }
    const obs = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting){
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.ayame-fade-up').forEach(el => obs.observe(el));
  }

  /* ---- 6. Auto-tag homepage main sections as fade-up ---- */
  function autoFadeSections(){
    document.querySelectorAll('main .shopify-section').forEach((s, i) => {
      // Skip the hero (already animates in) and header
      if (s.querySelector('.ayame-hero')) return;
      s.classList.add('ayame-fade-up');
    });
  }

  /* ---- 7. Boot ---- */
  function boot(){
    initStickyNav();
    initHeroLetters();
    initCrystals();
    initClickRipple();
    autoFadeSections();
    initScrollFade();
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Re-init on Shopify theme editor section change */
  document.addEventListener('shopify:section:load', () => setTimeout(boot, 100));
})();